import { render, staticRenderFns } from "./CommencePage.vue?vue&type=template&id=3875022b&"
import script from "./CommencePage.vue?vue&type=script&lang=js&"
export * from "./CommencePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports